
import { Component, OnInit } from '@angular/core';
import { CssVariableService } from '@services/css-variable.service';

export const themeColors = [
	{ key: "primary", value: "$yellow" },
	{ key: "success", value: "$green" },
	{ key: "info", value: "$purple" },
	{ key: "warning", value: "$orange" },
	{ key: "danger", value: "$danger" },
	{ key: "hover", value: "$gray-200" },
	{ key: "light", value: "$gray-400" },
	{ key: "dark", value: "$gray-800" },
	{ key: "success-light", value: "$success-light" },
	{ key: "warning-light", value: "$warning-light" },
	{ key: "danger-light", value: "$danger-light" },
	{ key: "danger-medium", value: "$danger-medium" }
]

@Component({
    selector: 'app-colors',
    templateUrl: './colors.component.html',
    styleUrls: ['./colors.component.scss'],
    imports: []
})
export class ColorsComponent implements OnInit {
	boxHeight = "7rem"

	themeColors = themeColors

	grayScale = [
		{ key: "white", comment: "" },
		{ key: "gray-050", comment: "" },
		{ key: "gray-100", comment: "ORCA: Gray, Usage: Trennlinien" },
		{ key: "gray-200", comment: "ORCA: Hover Gray, Usage:  Hover Katalog Items, Hover Tree Items, Rahmen hell, Gruppen Überschriften" },
		{ key: "gray-300", comment: "ORCA: former searchbar-border color" },
		{ key: "gray-400", comment: "ORCA: Light, Usage:  Rahmen Standard" },
		{ key: "gray-500", comment: "ORCA: Blue Gray, Usage: Teasertext, Text Muted" },
		{ key: "gray-600", comment: "ORCA: Medium Gray, Usage: Tooltip" },
		{ key: "gray-700", comment: "" },
		{ key: "gray-800", comment: "ORCA: Dark, Usage: Font Standard, Icon Standard" },
		{ key: "gray-900", comment: "" },
		{ key: "black", comment: "" },
	]

	colorDefinitions = [
		{ key: "blue" }, // ORCA: Blue, Usage: Externe Links
		{ key: "indigo" },
		{ key: "purple" },
		{ key: "pink" },
		{ key: "red" },
		{ key: "orange" },
		{ key: "yellow" },// ORCA: ADE-Gelb, Usage: Header Background, Button Rahmen
		{ key: "green" }, // ORCA
		{ key: "teal" },
		{ key: "cyan" },
	]



	constructor(
		private cssVariableService: CssVariableService
	) { }

	ngOnInit() {
	}

	getVarValue(name: string): string {
		return this.cssVariableService.getByName(name)
	}

}
